import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import settingsReducer from "../reduxSlices/settingSlices";
import permissionsReducer from "../reduxSlices/permissionsSlice";
import usersReducer from "../reduxSlices/userSlice";
import serviceReducer from "../reduxSlices/serviceSlice";

// Persist config for service slice (the one you want to persist)
const servicePersistConfig = {
  key: "service",
  storage,
};

// Persist config for settings (optional)
const settingsPersistConfig = {
  key: "settings",
  storage,
};

// Create persisted reducers
const persistedServiceReducer = persistReducer(
  servicePersistConfig,
  serviceReducer
);
const persistedSettingsReducer = persistReducer(
  settingsPersistConfig,
  settingsReducer
);

export const store = configureStore({
  reducer: {
    service: persistedServiceReducer,
    settings: persistedSettingsReducer,
    permissions: permissionsReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
